var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.600586,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7251 20.375V28.8125C39.7251 29.0611 39.6264 29.2996 39.4505 29.4754C39.2747 29.6512 39.0363 29.75 38.7876 29.75C38.539 29.75 38.3005 29.6512 38.1247 29.4754C37.9489 29.2996 37.8501 29.0611 37.8501 28.8125V22.6379L26.3259 34.1633C26.2388 34.2504 26.1354 34.3196 26.0216 34.3668C25.9078 34.414 25.7858 34.4382 25.6626 34.4382C25.5394 34.4382 25.4174 34.414 25.3036 34.3668C25.1898 34.3196 25.0864 34.2504 24.9993 34.1633L13.7493 22.9133C13.5734 22.7374 13.4746 22.4988 13.4746 22.25C13.4746 22.0012 13.5734 21.7626 13.7493 21.5867C13.9253 21.4108 14.1639 21.312 14.4126 21.312C14.6614 21.312 14.9 21.4108 15.0759 21.5867L25.6626 32.1746L36.5247 21.3125H30.3501C30.1015 21.3125 29.863 21.2137 29.6872 21.0379C29.5114 20.8621 29.4126 20.6236 29.4126 20.375C29.4126 20.1264 29.5114 19.8879 29.6872 19.7121C29.863 19.5363 30.1015 19.4375 30.3501 19.4375H38.7876C39.0363 19.4375 39.2747 19.5363 39.4505 19.7121C39.6264 19.8879 39.7251 20.1264 39.7251 20.375Z",
    fill: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpsIcon);
export default __webpack_public_path__ + "static/media/rpsIcon.2a52a2bf981ce485b55a72bc2881cce0.svg";
export { ForwardRef as ReactComponent };